import React from 'react';
import styled from 'styled-components';
import anchorme from 'anchorme';
import { ButtonAction, defaultCalendlyTimeSlots, FormFieldTypes, ShadowPosition } from 'containers/PageBuilder/SinglePageContainer/domain';
import PageBuilderService from 'api/services/page-builder';
import miscUtils from 'utils/miscUtils';
import 'react-phone-number-input/style.css';
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-number-input';
import useUAIP from 'hooks/useUAIP';
import Cookie from 'js-cookie';
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import BlockButton from '../BlockComponents/BlockButton';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import { IFormBlockPreviewProps } from './IFormBlockPreviewProps';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import InnerHTML from 'dangerously-set-html-content';
import AppSelect from 'elements/appSelect';
import { formatDateToLocal } from 'api/services/page-builder/domain';
import styles from './FormBlockPreview.module.scss';
import CalendlyEventTypeTimesSelector from 'components/PageBuilder/PageBuilderSideBar/PageBuilderWidgets/FormsContainer/PageFormSettings/PageFormFieldSettings/CalendlyEventTypeTimesSelector';
import ResizeObserver from 'resize-observer-polyfill';
import { ReactComponent as XIcon } from 'containers/channels/collections/deleteConfirmation/icons/x.svg';
import useGeoInfo from 'hooks/useGeoInfo';
import TurnstileWidget from 'components/TurnstileWidget/TurnstileWidget';
import { useAtom } from 'jotai';
import { isHumanVerifiedAtom } from 'showMessageMenuAtom';
import { useTurnstile } from 'react-turnstile';


const ContentWrapper: any = styled.div<{design: any, showCalendlySchedule: boolean}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${(props: any) => 
    props.showCalendlySchedule ?
    `0px` :
    props.design.content_wrapper_padding ?
    `${props.design.content_wrapper_padding}px` :
    `0px`
  };
  border-radius: ${(props: any) => 
    props.design.content_wrapper_border_radius &&
    props.design.content_wrapper_border_radius <= 30 ?
    `${props.design.content_wrapper_border_radius}px`:
    `0px`
  };
  border: ${(props: any) => 
    props.design.content_wrapper_border_color &&
    isValidHexColor(props.design.content_wrapper_border_color) ?
    `1px solid ${props.design.content_wrapper_border_color}` :
    `1px solid transparent` 
  };
  background-color: ${(props: any) => 
    props.design.content_wrapper_background_color &&
    isValidHexColor(props.design.content_wrapper_background_color) ?
    props.design.content_wrapper_background_color :
    'transparent'
  };
  box-shadow: ${(props: any) => 
    props.design.content_wrapper_shadow_color &&
    isValidHexColor(props.design.content_wrapper_shadow_color) ?
    props.design.content_wrapper_shadow_position === ShadowPosition.Even ?
    `0px 0px 8px rgba(${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.b}, ${props.design.content_wrapper_shadow_opacity ? props.design.content_wrapper_shadow_opacity : 0.0})` :
    props.design.content_wrapper_shadow_position === ShadowPosition.Bottom ?
    `0px 4px 8px rgba(${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.b}, ${props.design.content_wrapper_shadow_opacity ? props.design.content_wrapper_shadow_opacity : 0.0})` :
    props.design.content_wrapper_shadow_position === ShadowPosition.Top ?
    `0px -4px 8px rgba(${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.b}, ${props.design.content_wrapper_shadow_opacity ? props.design.content_wrapper_shadow_opacity : 0.0})` :
    props.design.content_wrapper_shadow_position === ShadowPosition.BottomRight ?
    `2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.b}, ${props.design.content_wrapper_shadow_opacity ? props.design.content_wrapper_shadow_opacity : 0.0})` :
    props.design.content_wrapper_shadow_position === ShadowPosition.BottomLeft ?
    `-2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.b}, ${props.design.content_wrapper_shadow_opacity ? props.design.content_wrapper_shadow_opacity : 0.0})` :
    props.design.content_wrapper_shadow_position === ShadowPosition.TopRight ?
    `2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.b}, ${props.design.content_wrapper_shadow_opacity ? props.design.content_wrapper_shadow_opacity : 0.0})` :
    props.design.content_wrapper_shadow_position === ShadowPosition.TopLeft ?
    `-2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.content_wrapper_shadow_color)!.b}, ${props.design.content_wrapper_shadow_opacity ? props.design.content_wrapper_shadow_opacity : 0.0})` :
    'none'
    :
    'none'
  };
`;

const FieldsContainer: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 25px;
`;

const FormGroupContainer: any = styled.div<{index: number}>`
  width: 100%;
  margin-top: ${(props: any) => 
    props.index ? 
    `10px` :
    `0px`
  };
`;

const FormGroupLabelContainer: any = styled.div`
  width: 100%;
`;

const FormGroupLabelText: any = styled.p<{design: any, pageStyles: any}>`
  margin: 0;
  padding: 0;
  font-weight: 400;

  font-size: ${(props: any) =>
    props.design.field_input_label_font_size &&
    props.design.field_input_label_font_size <= 50 ?
    `${props.design.field_input_label_font_size}px` :
    `20px`
  };
  line-height: ${(props: any) =>
    props.design.field_input_label_line_height &&
    props.design.field_input_label_line_height <= 50 ?
      `${props.design.field_input_label_line_height}px` :
      `25px`
  };
  font-family: ${(props: any) =>
    props.design.field_input_label_font_family ?
      `${props.design.field_input_label_font_family} !important` :
      `-apple-system, Arial !important`
  };
  color: ${(props: any) =>
    props.design.field_input_label_color &&
    isValidHexColor(props.design.field_input_label_color) ?
    props.design.field_input_label_color :
    '#000000'
  };
`;

const FormGroupLabelTextRequired: any = styled.span<{design: any}>`
  margin: 0;
  padding: 0;
  font-weight: 400;

  font-size: ${(props: any) =>
    props.design.field_input_label_font_size &&
    props.design.field_input_label_font_size <= 50 ?
    `${props.design.field_input_label_font_size}px` :
    `20px`
  };
  line-height: ${(props: any) =>
    props.design.field_input_label_line_height &&
    props.design.field_input_label_line_height <= 50 ?
      `${props.design.field_input_label_line_height}px` :
      `25px`
  };
  font-family: ${(props: any) =>
    props.design.field_input_label_font_family ?
      `${props.design.field_input_label_font_family} !important` :
      `-apple-system, Arial !important`
  };
  color: ${(props: any) =>
    props.design.field_input_required_color &&
    isValidHexColor(props.design.field_input_required_color) ?
    props.design.field_input_required_color :
    '#FF0000'
  };
`;

const FormGroupErrorText: any = styled(FormGroupLabelText)`
  margin-top: 5px;
  color: ${(props: any) =>
    props.design.field_input_required_color &&
    isValidHexColor(props.design.field_input_required_color) ?
    props.design.field_input_required_color :
    '#FF0000'
  };
`;

const FormGroupInputContainer: any = styled.div<{design: any, isError: boolean}>`
  width: 100%;
  border: ${(props: any) => 
    props.isError &&
    props.design.field_input_required_color &&
    isValidHexColor(props.design.field_input_required_color) ?
    `1px solid ${props.design.field_input_required_color}` :
    props.design.field_input_border_color &&
    isValidHexColor(props.design.field_input_border_color) ?
    `1px solid ${props.design.field_input_border_color}` :
    `1px solid #D5D8DF` 
  };
  border-radius: ${(props: any) => 
    props.design.field_input_border_radius &&
    props.design.field_input_border_radius <= 30 ?
    `${props.design.field_input_border_radius}px`:
    `0px`
  };
  margin-top: 5px;
  overflow: hidden;
`;

const FormGroupInputElement: any = styled.input<{design: any}>`
  font-size: ${(props: any) =>
    props.design.field_input_font_size &&
    props.design.field_input_font_size <= 50 ?
    `${props.design.field_input_font_size}px` :
    `20px`
  };
  line-height: ${(props: any) =>
    props.design.field_input_line_height &&
    props.design.field_input_line_height <= 50 ?
      `${props.design.field_input_line_height}px` :
      `25px`
  };
  font-family: ${(props: any) =>
    props.design.field_input_font_family ?
      `${props.design.field_input_font_family} !important` :
      `-apple-system, Arial !important`
  };
  color: ${(props: any) =>
    props.design.field_input_color &&
    isValidHexColor(props.design.field_input_color) ?
    props.design.field_input_color :
    '#000000'
  };
  width: 100%;
  height: ${(props: any) =>
    props.design.field_input_height &&
    props.design.field_input_height > 5 &&
    props.design.field_input_height < 100 ?
    `${props.design.field_input_height}px` :
    `44px`
  };
  border: none;
  padding: 0 10px;
  background-color: ${(props: any) =>
    props.design.field_input_background_color &&
    isValidHexColor(props.design.field_input_background_color) ?
    props.design.field_input_background_color :
    '#FFFFFF'
  };

  &:focus {
    outline: none;
  }

  &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }
  &::-moz-placeholder { /* Firefox 19+ */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }
  &:-ms-input-placeholder { /* IE 10+ */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }
  &::-ms-input-placeholder { /* Microsoft Edge */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }
  &::placeholder { /* Standard */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }
`;

const FormGroupPhoneInputElement: any = styled(PhoneInput)<{design: any}>`
  .PhoneInputCountry {
    margin-right: 0;
    padding-left: 10px;
    padding-right: 2px;
    background-color: ${(props: any) =>
      props.design.field_input_background_color &&
      isValidHexColor(props.design.field_input_background_color) ?
      props.design.field_input_background_color :
      '#FFFFFF'
    };
  }
  input[type="tel"] {
    font-size: ${(props: any) =>
      props.design.field_input_font_size &&
      props.design.field_input_font_size <= 50 ?
      `${props.design.field_input_font_size}px` :
      `20px`
    };
    line-height: ${(props: any) =>
      props.design.field_input_line_height &&
      props.design.field_input_line_height <= 50 ?
        `${props.design.field_input_line_height}px` :
        `25px`
    };
    font-family: ${(props: any) =>
      props.design.field_input_font_family ?
        `${props.design.field_input_font_family} !important` :
        `-apple-system, Arial !important`
    };
    color: ${(props: any) =>
      props.design.field_input_color &&
      isValidHexColor(props.design.field_input_color) ?
      props.design.field_input_color :
      '#000000'
    };
    width: 100%;
    height: ${(props: any) =>
      props.design.field_input_height &&
      props.design.field_input_height > 5 &&
      props.design.field_input_height < 100 ?
      `${props.design.field_input_height}px` :
      `44px`
    };
    border: none;
    padding: 0 10px;
    background-color: ${(props: any) =>
      props.design.field_input_background_color &&
      isValidHexColor(props.design.field_input_background_color) ?
      props.design.field_input_background_color :
      '#FFFFFF'
    };

    &:focus {
      outline: none;
    }
  
    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
    &::-moz-placeholder { /* Firefox 19+ */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
    &:-ms-input-placeholder { /* IE 10+ */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
    &::-ms-input-placeholder { /* Microsoft Edge */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
    &::placeholder { /* Standard */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
  }
`;

const FormButton: any = styled(BlockButton)<{isSubmitting: boolean}>`
  width: 100%;
  max-width: 100%;
  margin-top: 25px;
  opacity: ${(props: any) => 
    props.isSubmitting ?
    `.5` :
    `1`
  };
`;

const FormConsentContainer: any = styled.div`
  margin-top: 25px;
  width: 100%;
`

const FormConsentWrapper: any = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const FormConsentInput: any = styled.input<{design: any}>`
  width: 18px;
  height: 18px;
  border: ${(props: any) => 
    props.design.field_input_border_color &&
    isValidHexColor(props.design.field_input_border_color) ?
    `1px solid ${props.design.field_input_border_color}` :
    `1px solid #D5D8DF`
  };
`;

const FormConsentLabelTextContainer: any = styled(BlockTextContainer)`
  margin-left: 5px;
`;

const EmbedContentContainer: any = styled.div`
  margin-top: 10px;
  width: 100%;
  height: fit-content;
  border-radius: 0 0 .5rem .5rem;
  overflow: hidden;

  .calendly-inline-widget {
    min-width: 320px;
    height: calc(100vh - 300px);
    max-height: 700px;
    overflow: hidden;
  }
`;

const SubmittedTextContainer: any = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const IconContainer: any = styled.span<{design: any}>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 10px;
  margin-left: auto;
  margin-bottom: 10px;
  width: fit-content;

  svg {
    path {
      stroke: ${(props: any) => 
        props.design.close_icon_color &&
        isValidHexColor(props.design.close_icon_color) ?
        props.design.close_icon_color :
        '#333333'
      };
  }
`;

const isCalendlyScheduledEvent = (e: any) => {
  return e.data.event &&
         e.data.event.indexOf('calendly') === 0 &&
         e.data.event === 'calendly.event_scheduled'
}

const FormBlockPreview: React.FC<IFormBlockPreviewProps> = (props) => {

    const hideCalendlyEventTimeDropdownRef = React.useRef<any>(null);
    const showingCalendlyScheduleRef = React.useRef<boolean>(false);

    const [formData, setFormData] = React.useState({
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      consent: false,
      discrete: "",
    });

    const [formDataError, setFormDataError] = React.useState<any>({
      first_name: false,
      last_name: false,
      email: false,
      phone_number: false,
      consent: false,
    });

    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
    const [submitted, setSubmitted] = React.useState<boolean>(false);

    const {
      ua,
      ip
    } = useUAIP();
    const [showCalendlySchedule, setShowCalendlySchedule] = React.useState<boolean>(false);
    const [selectedEventTime, setSelectedEventTime] = React.useState<any>(null);
    const [fieldsContainerWidth, setFieldsContainerWidth] = React.useState<number>(0);

    const geoInfo = useGeoInfo();

    React.useEffect(() => {
      const handleCalendlyEvent = (e: MessageEvent) => {
        if (isCalendlyScheduledEvent(e)) {

          const sourceIframe: any = document.querySelector(`#${CSS.escape(props.blockData.render_id)} iframe`);

          if(
            sourceIframe &&
            sourceIframe.contentWindow &&
            sourceIframe.contentWindow === e.source
          ) {
            showingCalendlyScheduleRef.current = false;

            setTimeout(() => {
              onSubmitted();
            }, 2000);
          }
        }
      };
    
      window.addEventListener('message', handleCalendlyEvent);

      setTimeout(() => {
        const fieldsContainerElement: HTMLElement = document.getElementById(`page-builder-form-preview-fields-container-${props.blockData.render_id}`) as HTMLElement;

        if (fieldsContainerElement) {
          // Create a ResizeObserver to watch for changes in the div's size
          const resizeObserver = new ResizeObserver(() => {
            setFieldsContainerWidth(fieldsContainerElement.offsetWidth); // Update the state with the new width
          });
          
          // Start observing the div's size
          resizeObserver.observe(fieldsContainerElement);
    
          // Set the initial width
          setFieldsContainerWidth(fieldsContainerElement.offsetWidth);
    
          // Clean up the observer when the component unmounts
          return () => {
            resizeObserver.unobserve(fieldsContainerElement);
          };
        }
      }, 500);

      return () => {
        window.removeEventListener('message', handleCalendlyEvent);
      };
    }, []);

    React.useEffect(() => {
      if(selectedEventTime) {
        setSelectedEventTime(null);
      }
    }, [props.blockData.fields]);

    const getInputType = (fieldType: FormFieldTypes) => {
      switch(fieldType) {
        case FormFieldTypes.FirstName:
        case FormFieldTypes.LastName:
          return "text";
        case FormFieldTypes.Email:
          return "email"
        case FormFieldTypes.PhoneNumber:
          return "tel"
      }
    }

    const hasField = (fieldType: FormFieldTypes) => {
      let isField: boolean = false;

      props.blockData.fields.forEach((field: any) => {
        if(field.type === fieldType) {
          isField = true;
        }
      });

      return isField;
    }

    const getUserConsentField = () => {
      let userConsentField: any;

      props.blockData.fields.forEach((field: any) => {
        if(field.type === FormFieldTypes.UserConsent) {
          userConsentField = field;
        }
      });

      return userConsentField;
    }

    const getInputName: any = (fieldType: FormFieldTypes) => {
      switch(fieldType) {
        case FormFieldTypes.FirstName:
          return "first_name";
        case FormFieldTypes.LastName:
          return "last_name";
        case FormFieldTypes.Email:
          return "email"
        case FormFieldTypes.PhoneNumber:
          return "phone_number"
      }
    }

    const getInputValue = (fieldType: FormFieldTypes) => {
      switch(fieldType) {
        case FormFieldTypes.FirstName:
          return formData.first_name;
        case FormFieldTypes.LastName:
          return formData.last_name;
        case FormFieldTypes.Email:
          return formData.email;
        case FormFieldTypes.PhoneNumber:
          return formData.phone_number;
        default:
          return '';
      }
    }

    const onChangeFormField = (e: any) => {
      if(formDataError[e.target.name]) {
        setFormDataError({
          ...formDataError,
          [e.target.name]: false,
        });
      }

      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }

    const fieldIsRequired = (fieldType: FormFieldTypes) => {
      let isFieldRequired: boolean = false;

      props.blockData.fields.forEach((field: any) => {
        if(
          field.type === fieldType &&
          field.is_required
        ) {
          isFieldRequired = true;
        }
      });

      return isFieldRequired;
    }

    const validate = () => {
      let valid = true;

      if(formData.discrete) {
        valid = false;
      }

      const formDataErrorCopy = JSON.parse(JSON.stringify(formDataError));

      if(
        hasField(FormFieldTypes.FirstName) &&
        formData.first_name.trim() === "" &&
        fieldIsRequired(FormFieldTypes.FirstName)
      ) {
        formDataErrorCopy.first_name = true;
        valid = false;
      }

      if(
        hasField(FormFieldTypes.LastName) &&
        formData.last_name.trim() === "" &&
        fieldIsRequired(FormFieldTypes.LastName)
      ) {
        formDataErrorCopy.last_name = true;
        valid = false;
      }

      if(
        hasField(FormFieldTypes.Email) &&
        formData.email.trim() === "" &&
        fieldIsRequired(FormFieldTypes.Email)
      ) {
        formDataErrorCopy.email = true;
        valid = false;
      }

      if(
        hasField(FormFieldTypes.Email) &&
        formData.email.trim() &&
        !miscUtils.validateEmail(formData.email.trim())
      ) {
        formDataErrorCopy.email = true;
        valid = false;
      }

      if(
        hasField(FormFieldTypes.PhoneNumber) &&
        !isPossiblePhoneNumber(formData.phone_number) &&
        fieldIsRequired(FormFieldTypes.PhoneNumber)
      ) {
        formDataErrorCopy.phone_number = true;   
        valid = false;
      }

      if(
        hasField(FormFieldTypes.UserConsent) &&
        !formData.consent &&
        fieldIsRequired(FormFieldTypes.UserConsent)
      ) {
        formDataErrorCopy.consent = true;        
        valid = false;
      }

      if(!valid) {
        setFormDataError(formDataErrorCopy);
      }

      return valid;
    }

    const onSubmitted = () => {
      if(
        props.blockData.button_action === ButtonAction.URL
      ) {
        window.open(miscUtils.ensureHttps(props.blockData.button_url), '_self');
        return;
      }

      if(
          props.blockData &&
          props.blockData.button_action === ButtonAction.Page &&
          props.blockData.button_url
      ) {
          window.open(
              `${props.blockData.button_url}`, 
              '_self'
          );
          return;
      }
    }

    const onSubmittedCleanup = () => {
      setIsSubmitting(false);
        if(
          props.blockData.button_action !== ButtonAction.URL
        ) {
          setSubmitted(true);
        }
    }

  const [isHumanVerified, setisHumanVerified] = useAtom(isHumanVerifiedAtom) as any;
  const turnstile = useTurnstile();
  const turnstileWidgetIsAvailable = document.getElementById('cloudflaire-turnstile-widget');

    const requestFormSubmission = () => {
      setIsSubmitting(true);

      const payload: any = {
        ...formData,
      }

      const _fbc = Cookie.get('_fbc');

      if(_fbc) {
        payload.fbc = _fbc;
      }

      payload.ua = ua;
      payload.ip = ip;

      let session_token: any = undefined;
      if (isHumanVerified.isVerified && turnstileWidgetIsAvailable !== null) {
        session_token = isHumanVerified.session_token
      }

      PageBuilderService.getInstance()
      .submitFormLead(
        props.group && props.group.id,
        'community-page-blocks',
        props.blockData.id,
        {
          data: payload,
          ...(session_token && { session_token })
        },
      )
      .then(() => {
        Cookie.remove('_fbc', { path: "/", domain: window.location.hostname });
        if(hasField(FormFieldTypes.Calendly)) {
          showingCalendlyScheduleRef.current = true;
          setShowCalendlySchedule(true);
          setIsSubmitting(false);
          return;
        }
        onSubmitted();
      })
        .catch((error: any) => {
          console.error(error)
          new Error(error)
          setisHumanVerified({
            isVerified: false,
            session_token: undefined
          });
          turnstile && turnstile.reset();
        })
      .finally(() => {
        setisHumanVerified({
          isVerified: false,
          session_token: undefined
        });
        turnstile && turnstile.reset();
        if(!showingCalendlyScheduleRef.current) {
          onSubmittedCleanup();
        }
      });
    }

    const submitForm = () => {
      if(!validate()) {
        return;
      }

      if ((!isHumanVerified.isVerified && (turnstileWidgetIsAvailable !== null) && window.location.pathname.split('/')[1] === 'pages')) {
        return
      }

      if(props.buildingPreview || props.preview) {
        return;
      }

      requestFormSubmission();
    }

    const getErrorMessage = (field: any) => {
      if(
        field.type === FormFieldTypes.PhoneNumber
      ) {
        return `Please enter a valid phone number`
      }

      if(
        field.type === FormFieldTypes.Email &&
        formData.email.trim()
      ) {
        return `Please enter a valid email address`
      }

      return field.error_message ? 
        field.error_message :
        `${field.label} is required`
    }

    const getEmbedHtml = (url: string) => {
      return `
        <!-- Calendly inline widget begin -->
        <div id="${props.blockData.render_id}" class="calendly-inline-widget" data-url="${url}?hide_event_type_details=1&hide_gdpr_banner=1&name=${encodeURIComponent(`${formData.first_name} ${formData.last_name}`)}&email=${encodeURIComponent(`${formData.email}`)}"></div>
        <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async onload="handleCalendlyLoaded()"></script>
        <!-- Calendly inline widget end -->  `
    }

    const getInlineInputStyles = () => {   
      return {
        fontSize: 
          props.blockData.design.field_input_font_size &&
          props.blockData.design.field_input_font_size <= 50 ?
          `${props.blockData.design.field_input_font_size}px` :
          `20px`,
        lineHeight:
          props.blockData.design.field_input_line_height &&
          props.blockData.design.field_input_line_height <= 50 ?
          `${props.blockData.design.field_input_line_height}px` :
          `25px`,
        fontFamily:
          props.blockData.design.field_input_font_family ?
          `${props.blockData.design.field_input_font_family}` :
          `-apple-system, Arial`,
        color: 
          props.blockData.design.field_input_color &&
          isValidHexColor(props.blockData.design.field_input_color) ?
          props.blockData.design.field_input_color :
          '#000000',
      }
    }

    const getFieldInput = (field: any) => {
      if(field.type === FormFieldTypes.Calendly) {
        return (
          <>
            <AppSelect
            hideDropdownRef={hideCalendlyEventTimeDropdownRef}
            value={selectedEventTime ? `${formatDateToLocal(selectedEventTime.start_time)}${miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone()) ? ` (${miscUtils.getUserTimezoneAbbreviation()} ${miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone())})` : ''}` : ''}
            noCaret
            cursorPointer
            useTippy
            tippyPlacement="bottom-start"
            tippyContainerClassName={`${styles.dropdown_popup_container}${props.buildingPreview ? ' building-preview' : ''}`}
            popupStyles={{
              width: `${fieldsContainerWidth}px`,
              overflow: 'hidden',
              backgroundColor: 
                props.blockData.design.dropdown_background_color &&
                isValidHexColor(props.blockData.design.dropdown_background_color) ?
                props.blockData.design.dropdown_background_color :
                '#FFFFFF',
              borderColor: 
                props.blockData.design.dropdown_border_color &&
                isValidHexColor(props.blockData.design.dropdown_border_color) ?
                props.blockData.design.dropdown_border_color :
                '#D5D8DF',
              borderRadius:
                props.blockData.design.dropdown_border_radius &&
                props.blockData.design.dropdown_border_radius <= 30 ?
                `${props.blockData.design.dropdown_border_radius}px`:
                `4px`,
            }}
            pageBuilderView
            pageBuilderViewDesign={props.blockData.design}
            inputClassName={styles.dropdown_input}
            placeholder={field.placeholder ? field.placeholder : 'Select time'}
            inputIconClassName={styles.dropdown_input_icon}
            >
                <CalendlyEventTypeTimesSelector
                group={props.group}
                eventTypeUri={field.eventType ? field.eventType.uri : ''}
                selectItem={(eventTime: any) => {
                    setSelectedEventTime(eventTime);
                }}
                elementContainerClass={styles.dropdown_option_container}
                slots={field.slots ? field.slots : defaultCalendlyTimeSlots}
                labelStyles={getInlineInputStyles()}
                />
            </AppSelect>
          </>
        )
      }

      if(field.type === FormFieldTypes.PhoneNumber) {
        return (
          <FormGroupPhoneInputElement
          international
          countryCallingCodeEditable={false}
          design={props.blockData.design}
          placeholder={field.placeholder}
          defaultCountry={geoInfo ? geoInfo.country_code : 'US'}
          value={getInputValue(field.type)}
          onChange={(value: any) => {
            if(value) {
              if(formDataError.phone_number) {
                setFormDataError({
                  ...formDataError,
                  phone_number: false,
                });
              }
        
              setFormData({
                ...formData,
                phone_number: value,
              });
            }
          }}
          />
        )
      }
      return (
        <FormGroupInputElement
        design={props.blockData.design}
        type={getInputType(field.type)}
        placeholder={field.placeholder}
        name={getInputName(field.type)}
        value={getInputValue(field.type)}
        onChange={onChangeFormField}
        />
      )
    }

    const getBlockContent = () => {
      if(showCalendlySchedule) {
        return (
            <EmbedContentContainer
            >
              <IconContainer
              design={props.blockData.design}
              onClick={() => setShowCalendlySchedule(false)}
              >
                <XIcon
                />
              </IconContainer>
              <InnerHTML
              html={getEmbedHtml(selectedEventTime ? selectedEventTime.scheduling_url : '')}
              />
            </EmbedContentContainer>
        )
      }

      return (
        <>
         {submitted ? (
          <>
          <SubmittedTextContainer
          >
            <BlockTextContainer
            design={props.blockData.design}
            pageStyles={props.pageStyles}
            textKey="submission_message"
            fallbackTextColor="#333333"
            dangerouslySetInnerHTML={{
                __html: anchorme(
                  props.blockData.submission_message &&
                  miscUtils.stripHTML(props.blockData.submission_message).length ?
                  props.blockData.submission_message : 
                  `<p>Thank you for your submission!</p>`
                ),
            }}
            />
          </SubmittedTextContainer>
          </>
         ) : (
          <>
          <BlockTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="heading"
          fallbackTextColor="#FFFFFF"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.heading),
          }}
          />


          <BlockSubTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="subtext"
          fallbackTextColor="#FFFFFF"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.subtext),
          }}
          />

          <FieldsContainer
          id={`page-builder-form-preview-fields-container-${props.blockData.render_id}`}
          >
              {props.blockData.fields.map((field: any, index: number) => {
              if(field.type === FormFieldTypes.UserConsent) {
                  return <></>
              }

              return (
                  <FormGroupContainer
                  index={index}
                  >
                  <FormGroupLabelContainer
                  >
                      <FormGroupLabelText
                      design={props.blockData.design}
                      >
                      {field.label}
                      {field.is_required ? (
                          <FormGroupLabelTextRequired
                          design={props.blockData.design}
                          >
                          *
                          </FormGroupLabelTextRequired>
                      ) : <></>}
                      </FormGroupLabelText>
                  </FormGroupLabelContainer>
                  <FormGroupInputContainer
                  design={props.blockData.design}
                  isError={formDataError[getInputName(field.type)]}
                  >
                      {getFieldInput(field)}
                  </FormGroupInputContainer>
                  {formDataError[getInputName(field.type)] ? 
                      <FormGroupErrorText
                      design={props.blockData.design}
                      >
                      <FormGroupLabelTextRequired
                      design={props.blockData.design}
                      >
                          *
                      </FormGroupLabelTextRequired>
                      {
                          getErrorMessage(field)
                      }
                      </FormGroupErrorText> 
                      : 
                      <></>
                  }
                  </FormGroupContainer>
              )
              })}
              <div
              className={styles.discrete}
              >
                <input
                type="text"
                name="discrete"
                value={formData.discrete}
                onChange={onChangeFormField}
                />
              </div>
          </FieldsContainer>

                <TurnstileWidget
                  group={props.group}
                  widgetBodyStyles={styles.widgetBodyStyles}
                  widgetpTgaStyles={styles.widgetpTgaStyles}
                  widgetpTgaStylesRequired={styles.widgetpTgaStylesRequired} 
                  design={props.blockData.design}
                />

          <FormButton
          design={props.blockData.design}
          isSubmitting={isSubmitting}
          pageStyles={props.pageStyles}
          onClick={() => submitForm()}
          disabled={isSubmitting}
          >
              {isSubmitting ? `Saving...` : props.blockData.button_text}
          </FormButton>

          {hasField(FormFieldTypes.UserConsent) ? (
              <FormConsentContainer
              >
              <FormConsentWrapper
              >
                  <FormConsentInput
                  design={props.blockData.design}
                  type="checkbox"
                  checked={formData.consent}
                  onClick={() => {
                  if(formDataError.consent) {
                      setFormDataError({
                      ...formDataError,
                      consent: false,
                      });
                  }
                  setFormData({
                      ...formData,
                      consent: !formData.consent,
                  })
                  }}
                  />
                  <FormConsentLabelTextContainer
                  design={{
                  ...props.blockData.design,
                  text_alignment: 'left',
                  }}
                  pageStyles={props.pageStyles}
                  textKey="user_consent"
                  fallbackTextColor="#333333"
                  dangerouslySetInnerHTML={{
                      __html: anchorme(getUserConsentField().label),
                  }}
                  />
              </FormConsentWrapper>
              {formDataError.consent ? 
                  <FormGroupErrorText
                  design={props.blockData.design}
                  >
                  <FormGroupLabelTextRequired
                  design={props.blockData.design}
                  >
                      *
                  </FormGroupLabelTextRequired>
                  {
                      getUserConsentField().error_message ? 
                      getUserConsentField().error_message :
                      `Please check the box to continue`
                  }
                  </FormGroupErrorText> 
                  : 
                  <></>
              }
              </FormConsentContainer>
          ) : <></>}
          </>
         )}
        </>
      )
    }
    
  return (
        <BlockContainer
        design={props.blockData.design}
        >
            <BlockContentContainer
            design={props.blockData.design}
            >
                <ContentWrapper
                design={props.blockData.design}
                showCalendlySchedule={showCalendlySchedule}
                >
                  {getBlockContent()}
                </ContentWrapper>
            </BlockContentContainer>
        </BlockContainer>
  )
}

export default FormBlockPreview;